/* @flow */
import * as React from "react";

type Props<EventType> = {
  target: ?EventTarget,
  eventName: string,
  handler: (EventType) => void,
};

export default class DOMEventListener<EventType: Event> extends React.Component<
  Props<EventType>
> {
  componentDidMount() {
    this._listen(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props<EventType>) {
    if (
      this.props.target === nextProps.target &&
      this.props.eventName === nextProps.eventName &&
      this.props.handler === nextProps.handler
    ) {
      return;
    }

    this._stopListening(this.props);
    this._listen(nextProps);
  }

  componentWillUnmount() {
    this._stopListening(this.props);
  }

  _listen({ target, eventName, handler }: Props<EventType>) {
    if (target == null) {
      return;
    }

    // $FlowIgnore
    target.addEventListener(eventName, handler);
  }

  _stopListening({ target, eventName, handler }: Props<EventType>) {
    if (target == null) {
      return;
    }

    // $FlowIgnore
    target.removeEventListener(eventName, handler);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/DOMEventListener.jsx